import React from "react";

export default function SQLServer_SUM() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_SUM</h1>
      <p>This is the SQLServer_SUM component generated from the SQL JSON.</p>
    </div>
  );
}
